import {Deserializable} from './deserializable';
import {BaseModel} from './baseModel';


export class AccessLogFilter extends BaseModel implements Deserializable {

  userUid: string;
  state: string;
  from: Date;
  to: Date;
  deviceSerial: string;

  deserialize(input: any) {

    super.deserialize(input);
    Object.assign(this, input);

    return this;
  }
}
